import { ApiRequestGet } from "../data/network/services/ApiRequestGet";
import { authSliceReducerSlice } from "../data/redux/slice/authSlice";
import {
  SS_AUTH_TOKEN,
  SS_REFRESH_TOKEN,
  SS_ROLE,
  SS_WHITELABELED,
  SS_WHITELISTED_LOGO,
} from "../utility/constants/secureStorageManager";
import { RESELLER, STATUS_CODE_200 } from "../utility/constants/valueConstants";
import secureStorage from "./secureStorage";

export const logoutService = () => (dispatch) => {
  let whitelabel = false;

  let logo = "";

  const role = secureStorage.getItem(SS_ROLE);

  if (role === RESELLER) {
    whitelabel = secureStorage.getItem(SS_WHITELABELED);

    logo = secureStorage.getItem(SS_WHITELISTED_LOGO);
  }
  secureStorage.clear();
  if (whitelabel && role === RESELLER) {
    secureStorage.setItem(SS_WHITELISTED_LOGO, logo);
  }
  dispatch(authSliceReducerSlice(false));
};

export const checkForUnauthorized = () => {
  const token = secureStorage.getItem(SS_REFRESH_TOKEN);
  ApiRequestGet.createNewToken({
    token,
  })
    .then((response) => {
      if (response.statusCode === STATUS_CODE_200) {
        secureStorage.setItem(SS_AUTH_TOKEN, response?.data?.token);
        secureStorage.setItem(SS_REFRESH_TOKEN, response?.data?.refreshToken);
        window.location.reload();
      } else {
        // dispatch(logoutService());
      }
    })
    .catch((error) => {});
};
